<template>
    <div class="background-image">
        <div class="nav-bar">
        </div>
        </div>
</template>

<style scoped>
.background-image{
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100vw;
    min-height: 100vh;
    background: url('@/assets/UC.png') no-repeat center center;
    background-size: cover;
    z-index: -1;
}
.nav-bar{
    position: absolute;
    width: 100vw;
    height: 10vh;
    background-color:#FFC434;
    background-image: url("@/assets/logogruas.png");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
}

</style>

<script>
import axios from 'axios';

export default {
  data() {
    return {
    //   contrato: 'a6db37e7-f4f1-412f-a09a-9a2ce2334f9d', // Initialize contrato variable
    //   xmlData: `<?xml version='1.0' encoding='UTF-8'?><cfdi:Comprobante xmlns:cfdi="http://www.sat.gob.mx/cfd/4" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" Version="4.0" Serie="A" Folio="123456" Fecha="2024-04-26T20:15:25" Sello="EOWot9vmrJv4SgnGDXLbIVIv2rZF19aKLODrrBhKkZnxQczUGE0u+Na3NDZNba5zhqmKg5XvluXqFb4eGxcfN5eAnyDbBt0pUPITqGFHxnSZn1mKRHBEpBpGlawjyLg1LfaAYlwMb7d7mqgkHkZK23Ni7WVU1KgCRnSlpQF5xOs1VHSR1obl8DZN0V9thLnxmX443iBUxpzqX4eZZtl4Wr/gzQKu6tzxsYHcoa2NKMvRym+BC/7Ld6pLj8VpBvzXMk21q4hSqxw/dgNGFYQQG+W+3HBFxACkKXUmy+8FnQtYXb4aSGc53NnpMWDc7jiD/1WnUavQPrRmvnpcEgQ6fw==" FormaPago="99" NoCertificado="30001000000500003442" Certificado="MIIFuTCCA6GgAwIBAgIUMzAwMDEwMDAwMDA1MDAwMDM0NDIwDQYJKoZIhvcNAQELBQAwggErMQ8wDQYDVQQDDAZBQyBVQVQxLjAsBgNVBAoMJVNFUlZJQ0lPIERFIEFETUlOSVNUUkFDSU9OIFRSSUJVVEFSSUExGjAYBgNVBAsMEVNBVC1JRVMgQXV0aG9yaXR5MSgwJgYJKoZIhvcNAQkBFhlvc2Nhci5tYXJ0aW5lekBzYXQuZ29iLm14MR0wGwYDVQQJDBQzcmEgY2VycmFkYSBkZSBjYWxpejEOMAwGA1UEEQwFMDYzNzAxCzAJBgNVBAYTAk1YMRkwFwYDVQQIDBBDSVVEQUQgREUgTUVYSUNPMREwDwYDVQQHDAhDT1lPQUNBTjERMA8GA1UELRMIMi41LjQuNDUxJTAjBgkqhkiG9w0BCQITFnJlc3BvbnNhYmxlOiBBQ0RNQS1TQVQwHhcNMjMwNTE4MTI1OTI2WhcNMjcwNTE4MTI1OTI2WjCB4DEqMCgGA1UEAxMhWEVOT04gSU5EVVNUUklBTCBBUlRJQ0xFUyBTIERFIENWMSowKAYDVQQpEyFYRU5PTiBJTkRVU1RSSUFMIEFSVElDTEVTIFMgREUgQ1YxKjAoBgNVBAoTIVhFTk9OIElORFVTVFJJQUwgQVJUSUNMRVMgUyBERSBDVjElMCMGA1UELRMcWElBMTkwMTI4SjYxIC8gVkFEQTgwMDkyN0RKMzEeMBwGA1UEBRMVIC8gVkFEQTgwMDkyN0hTUlNSTDA1MRMwEQYDVQQLEwpTdWN1cnNhbCAxMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAga5zxQ4mEBE4LobElO0+UyMDcAYbY0NJbg4xNbvwd66CUuTjyK2q11Y6nTzod1I1Nhv75cfZbJzdW/4EO/1bGLEt3zpTnP0yDVh9KL4/WJ0QW5kR4QVpxd84aBkJe7FltC5j+FUiDSCCLpSBlGvwZdFAwZhSZvHeFB1i1pDc3rA/PvqJwn35goEdIfhgfymg+31LuL1stU30pOSYtxltiEoM3QFePVurYhYqsxNmZMGkRvVNrf/SnZsiaLUonM8CNLfhJIFxBraH3qeZ3iCaeFgL8zO5ux+8D1XAg2RpJLf7gFVC9fWOc9yaHKNsjkt1E2YauH9KpHxRAjt3zKniywIDAQABox0wGzAMBgNVHRMBAf8EAjAAMAsGA1UdDwQEAwIGwDANBgkqhkiG9w0BAQsFAAOCAgEAR73vD0WGeWtnZyIFixfsNtvM3068JFvn4LJ0aF0ZZwTJhcff7OrUrpsrCjMzpIOB3Lfq5DLtaIPNeEkSa5W4yi1XJ930kcJ4kubi16jmTIMIZ7w9fy8p99gggTMbYiFf0Jzvfz+PQqqpsfnc3lMVV/GkHvs8QHEekZxpWHS22oE/S5wKq7b85oW649fC834EoZGIsb80Rna4ATuDxbt3dvzTR/b/eyricihMBqQ1MPCi9D81o1/3EPEOZNYFcC+yQK7M+/C7pivs0A972q8LYxG8DzmaKV8zLg+IR9ygdYdl/y/Snoeo0udV4yUlzug7i5IGZbfUh2jo3WEkEdIpty+lcVt2PtWOTdR70V0oCivE0MV0qw9GRzFAr6G71fra6r+sUKUwxQBn07pi6hHmmZ7/DZ9QCaheqD9ttdhlQhpTTt0UPpWY9CDUJKpbWlkKYUzLPkdf/ppjiizbP1fqDcoIfZxl4RPKKtr0eIJWhEnuVirZ0kevHXEspI+igdMqk8MRndZSoohuIuLdjKjfXEGBALoqUzAB6avN2zzEy6ERRCGfR3cVhVUTcpd/iQffeGvw7tRZZOiWgwG3Sjc/zgUppnFXfVFHCTmRz1nr0dOqKjOpMEMncRSfY2Mk+Xm8rmJ7toBu4iAyJUDCP6v24as1uxiE9DVDaFwlugdYL9c=" SubTotal="1250.30" Moneda="MXN" Total="1191.95" TipoDeComprobante="I" Exportacion="01" MetodoPago="PPD" LugarExpedicion="56820" xsi:schemaLocation="http://www.sat.gob.mx/cfd/4 http://www.sat.gob.mx/sitio_internet/cfd/4/cfdv40.xsd"><cfdi:Emisor Rfc="XIA190128J61" Nombre="XENON INDUSTRIAL ARTICLES" RegimenFiscal="601"/><cfdi:Receptor Rfc="KIJ0906199R1" Nombre="KIJ, S.A DE C.V." DomicilioFiscalReceptor="59820" RegimenFiscalReceptor="601" UsoCFDI="G03"/><cfdi:Conceptos><cfdi:Concepto ClaveProdServ="84111506" Cantidad="1.00" ClaveUnidad="E48" Descripcion="SERVICIOS DE FACTURACION" ValorUnitario="1250.30" Importe="1250.30" ObjetoImp="02"><cfdi:Impuestos><cfdi:Traslados><cfdi:Traslado Base="1250.30" Impuesto="002" TipoFactor="Tasa" TasaOCuota="0.160000" Importe="200.05"/></cfdi:Traslados><cfdi:Retenciones><cfdi:Retencion Base="1250.30" Impuesto="001" TipoFactor="Tasa" TasaOCuota="0.100000" Importe="125.03"/><cfdi:Retencion Base="1250.30" Impuesto="002" TipoFactor="Tasa" TasaOCuota="0.106667" Importe="133.37"/></cfdi:Retenciones></cfdi:Impuestos></cfdi:Concepto></cfdi:Conceptos><cfdi:Impuestos TotalImpuestosRetenidos="258.40" TotalImpuestosTrasladados="200.05"><cfdi:Retenciones><cfdi:Retencion Impuesto="001" Importe="125.03"/><cfdi:Retencion Impuesto="002" Importe="133.37"/></cfdi:Retenciones><cfdi:Traslados><cfdi:Traslado Base="1250.30" Impuesto="002" TipoFactor="Tasa" TasaOCuota="0.160000" Importe="200.05"/></cfdi:Traslados></cfdi:Impuestos></cfdi:Comprobante>`
    };
  },
  mounted() {
    this.sendPostRequest(); // Call sendPostRequest method when the component is mounted
  },
  methods: {
    sendPostRequest() {
      // Define the URL of your Django REST Framework endpoint
      const apiDirectory = process.env.API_DIRECTORY;
      const url = `${apiDirectory}/invoice-stamping`;

      // Define the data to be sent in the request body
      const postData = {
        contrato: this.contrato,
        xmlData: this.xmlData
      };

      // Send the POST request using Axios
      axios.post(url, postData)
        .then(response => {
          // Handle successful response
          console.log('Response:', response.data);
        })
        .catch(error => {
          // Handle error
          console.error('Error:', error);
        });
    }
  }
};
</script>
